<template>
  <div>
    <h2 class="graph-title">
      Flag Breakdown
    </h2>
    <div class="grid-x chart-container">
      <div class="small-10">
        <div
          class="flag-breakdown-chart-container"
          :style="{ height: chartHeight }"
        >
          <canvas :id="canvasID" />
        </div>
      </div>
      <div class="small-2">
        <ul class="chart-numbers">
          <li
            v-for="n in 6"
            :key="n"
          >
            <div
              v-for="i in datapoints"
              :key="i"
            >
              <span
                class="dataNumber"
                :style="{ color: textColors[i - 1] }"
              >
                {{ formatDataLabel(dataToRender[i - 1][n - 1]) }}
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'RareFlagBreakDownChart',
  props: {
    chartData: {
      type: Array,
      required: true,
    },
    canvasID: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      chartOptions: {
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [{
            display: true,
            categoryPercentage: 0.5,
            barThickness: 20,
            ticks: {
              display: true,
            },
            gridLines: {
              display: false,
              color: '#FFFFFF',
            },
          }],
          xAxes: [{
            display: false,
            categoryPercentage: 0.5,
            barThickness: 20,
            ticks: {
              display: false,
            },
          }],
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      chartLabels: 'legendData',
      chartColors: 'fetchBarColors',
      textColors: 'fetchTextColors',
    }),
    dataToRender() {
      let dataToReturn;
      if (this.$store.getters.industryCompAndDecimalException) {
        dataToReturn = this.chartData.slice(0, 1);
      } else {
        dataToReturn = this.chartData;
      }
      return dataToReturn;
    },
    datapoints() {
      return this.dataToRender.length;
    },
    chartHeight() {
      let height = '400px';
      if (this.datapoints === 4) {
        height = '660px';
      }
      if (this.$store.getters.industryCompAndDecimalException || this.dataToRender.length === 1) {
        height = '270px';
      }
      return height;
    },
  },
  watch: {
    data: function () { // eslint-disable-line
      this.buildChart();
    },
  },
  beforeUpdate() {
    this.buildChart();
  },
  created() {
    Chart.scaleService.updateScaleDefaults('linear', {
      ticks: {
        min: 0,
      },
    });
  },
  mounted() {
    this.buildChart();
  },
  methods: {
    buildChart() {
      const flagBreakdownChartCTX = document.getElementById(this.canvasID)
        .getContext('2d');

      function storeImageAsBase64() {
        window.summaryFlagBreakdownChartImg = flagChart.toBase64Image();
      }

      const { chartOptions } = this;
      chartOptions.animation = {
        onComplete: storeImageAsBase64,
      };

      const dataSetsArray = [];
      for (let x = 0; x < this.datapoints; x += 1) {
        if (this.dataToRender[x] === 'N/A') { this.dataToRender[x] = 0; }
        dataSetsArray.push(
          {
            label: this.chartLabels[x],
            backgroundColor: this.chartColors[x],
            data: this.chartData[x],
          },
        );
      }

      if (window.flagChart !== undefined) {
        window.flagChart.destroy();
      }
      window.flagChart = new Chart(flagBreakdownChartCTX, {
        type: 'horizontalBar',
        data: {
          labels: ['5 Flags', '4 Flags', '3 Flags', '2 Flags', '1 Flags', '0 Flags'],
          datasets: dataSetsArray,
        },
        options: this.chartOptions,
      });
    },

    formatDataLabel(string) {
      let returnValue;
      if (string === 'N/A') {
        returnValue = string;
      } else {
        const percentage = (this.$store.getters.dataFormat === 'percentage' ? '%' : '');
        returnValue = `${string}${percentage}`;
      }
      return returnValue;
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .chart-container {
    border-bottom: 1px solid $common-mid-grey;
    border-top: 1px solid $common-mid-grey;
    margin-top: 35px;
  }

  .chart-numbers {
    margin-left: 0;
  }

  .chart-numbers li {
    width: 50px;
    margin-bottom: 21px;
  }

  .flag-breakdown-chart-container {
    width: 302px;
  }

  .chart-numbers {
    list-style: none;
    margin-top: 15px;
  }

  .dataNumber {
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 20px;
    letter-spacing: 1px;
    text-align: right;
  }

</style>
